export const GOCARDLESS = "GOCARDLESS";
